export const GOCARDLESS = "GOCARDLESS";
